import React from 'react';
import css from './Sections.module.css';

function SectionAbout({ intl }) {
  return (
    <div className={css.aboutContainer}>
      <div className={css.fixedWidthContainer}>
        {intl.formatMessage({ id: 'SectionAbout.description' })}
      </div>
    </div>
  );
}

export default SectionAbout;